import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IMetricCost } from "./metric-cost";
import { IMetricCountyCount } from "./metric-county-count";
import { IMetricRequest } from "./metric-request";
import { IMetricStatusCount } from "./metric-status-count";
import { environment } from '@env/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})

export class MetricService {
  private api: string;

  constructor(private httpService: HttpClient)
  {
    this.api = environment.privateApi + "calltracker/metrics/";
  }

  getStatusCounts(request: IMetricRequest): Observable<IMetricStatusCount> {
    return this.httpService.post<IMetricStatusCount>(this.api + 'status', request, httpOptions);
  }

  getCosts(request: IMetricRequest): Observable<IMetricCost[]> {
    return this.httpService.post<IMetricCost[]>(this.api + 'cost', request, httpOptions);
  }

  getCountyCounts(request: IMetricRequest): Observable<IMetricCountyCount[]> {
    return this.httpService.post<IMetricCountyCount[]>(this.api + 'counties', request, httpOptions);
  }
}
